export default {
  name: 'shareConfig',
  labelWidth: '100px',
  type: 'fieldset',
  text: '设置分享文案',
  checkbox: true,
  expend: true,
  items: [{
    text: '分享链接',
    name: 'link',
    rules: {
      validator: ({ value, callback }, data, vm) => {
        if (vm?.$store?.getters?.env === 'test') {
          callback();
        }
        if (value.includes('beta.m.film.qq.com')) {
          callback(new Error('该链接为预发布地址'));
        } else if (value.includes('beta.film.qq.com')) {
          callback(new Error('该链接为预览地址'));
        } else {
          callback();
        }
      },
      trigger: 'blur',
    },
  }, {
    text: '分享标题',
    name: 'title',
    rules: [{ required: true, message: '请输入分享标题', trigger: 'blur' }],
  }, {
    text: '朋友圈标题',
    name: 'timeLineTitle',
    rules: [{ required: true, message: '请输入分享朋友圈标题', trigger: 'blur' }],
  }, {
    text: '分享描述',
    name: 'desc',
    rules: [{ required: true, message: '请输入分享描述', trigger: 'blur' }],
  }, {
    text: '分享图片',
    name: 'imgUrl',
    type: 'upload',
    drag: true,
    rules: [{ required: true, message: '请设置分享图片', trigger: 'blur' }],
  }],
};
